export default (state = {}, { type, payload }) => {
  return state;
};
